var map = {
	"./": 135,
	"./Clutch": 2653,
	"./Clutch.js": 2653,
	"./NewUi": 2654,
	"./NewUi.js": 2654,
	"./OldUi": 2655,
	"./OldUi.js": 2655,
	"./index": 135,
	"./index.js": 135,
	"./style": 849,
	"./style.js": 849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4165;